<template>
  <div class="classroom-container">
    <div class="group-summary">
      <div class="summary">
        <div class="">
          <ul class="mini-tabs is-left">
            <li class="is-active"><a>
              <v-color-icon name="inbox"></v-color-icon>
              总结</a>
            </li>
            <li class="flex-pull-right">
              <v-transition name="slide-right">
                <button v-if="group.commits"
                        class="button is-success is-small is-outlined is-rounded">
                  <v-color-icon name="check"></v-color-icon>
                  <span>{{ (group.commits.commit_at || new Date()) | simple_date_time }} 完成</span>
                </button>
              </v-transition>
            </li>
          </ul>

          <section class="section has-border-bottom">
            <div class="section-index">
              <v-transition name="slide-down">
                <span>{{ group.name }}</span>
              </v-transition>
            </div>
            <div class="before-title">{{ course.name }}</div>
            <v-transition name="slide-down">
              <h1 class="title">
                <b>{{ group.name }}</b>
              </h1>
            </v-transition>

            <v-transition name="slide-right">
              <div class="buttons">
                <a class="button is-link is-outlined is-rounded"
                   @click="reStudy">
                  <v-color-icon name="restart"></v-color-icon>
                  <span>重学本节</span>
                </a>
                <a v-if="problems.length"
                   class="button is-link is-outlined is-rounded"
                   target="_blank"
                   :href="`https://python123.io/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/intro`">
                  <v-color-icon name="arrow-right"></v-color-icon>
                  <span>浏览题目</span>
                </a>
              </div>
            </v-transition>


          </section>
          <v-transition name="slide-up">

            <div class="columns is-variable is-0 is-multiline">
              <div class="column is-12 is-6-widescreen">
                <v-transition name="slide-up">
                  <section class="section">
                    <span class="section-index">A</span>
                    <h1 class="title is-small">
                      <v-color-icon name="inbox" size="42"></v-color-icon>
                      课堂小节
                    </h1>
                    <div class="content notebook-content">
                      <div v-html="group.content"></div>
                    </div>
                  </section>
                </v-transition>

              </div>
              <div class="column is-12 is-6-widescreen">

                <section v-if="problems.length"
                         class="section">
                  <span class="section-index">C</span>
                  <h1 class="title is-small">
                    <v-color-icon name="medal" size="42"></v-color-icon>
                    成绩单
                  </h1>
                  <transcript
                      :problems="problems"
                      :transcript="transcript">
                  </transcript>
                </section>
              </div>
              <div class="column is-12">
                <v-transition name="slide-up">
                  <section v-if="$isDataLoaded(blocks) && blocks.length"
                           class="section">
                    <span class="section-index">B</span>
                    <h1 class="title is-small">
                      <v-color-icon name="inbox" size="42"></v-color-icon>
                      知识卡
                    </h1>
                    <div class="columns is-multiline is-variable is-3">
                      <div v-for="(block) in blocks" class="column is-12 is-6-desktop is-4-fullhd">
                        <block-card
                            :key="'block' + block._id"
                            :block="block"></block-card>
                      </div>
                    </div>
                  </section>
                </v-transition>

              </div>
            </div>
          </v-transition>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockCard from '@/components/classroom/web/partial/BlockCard'
import IClassroom from '@/components/classroom/lib/IClassroom'
import Transcript from '@/components/classroom/messages/partials/Transcript'
import SoundEffect from '@/components/classroom/lib/SoundEffect'

const IDE = window['IDE']

export default {
  components: { BlockCard, Transcript },
  props: ['course', 'group'],
  data () {
    return {
      IDE,
      IClassroom,
      SoundEffect
    }
  },
  mounted () {
    IDE.toggleNav(true)
  },
  computed: {
    blocks () {
      let blocks = this.$api.getData('/student/courses/:courseId/groups/:groupId/blocks', {
        courseId: IClassroom.course._id,
        groupId: IClassroom.group._id
      })
      if (this.$isDataLoaded(blocks)) {
        if (!this.group.commits || !this.group.commits.win) {
          blocks = blocks.filter(block => {
            return block.name.indexOf('菜谱') === -1
          })
        }
      }
      return blocks
    },
    transcript () {
      if (!this.$isDataLoaded(this.group) || !this.group.done) {
        return []
      }
      return this.$api.getData('/student/courses/:courseId/groups/:groupId/transcript', {
        courseId: IClassroom.course._id,
        groupId: IClassroom.group._id
      })
    },
    problems () {
      return this.$api.getData('/student/courses/:courseId/groups/:groupId/problems?take_id=' + this.takeId, {
        courseId: IClassroom.course._id,
        groupId: IClassroom.group._id
      })
    }
  },
  methods: {
    reStudy () {
      IClassroom.enterGroup({ ...IClassroom.group, done: '' })
    }
  }
}
</script>
<style lang="stylus" scoped>
@keyframes summary-enter {
  0% {
    transform: translateY(-2rem)
  }

  100% {
    transform: translateY(0rem)
  }
}

.group-summary {
  overflow auto
  min-height 100%
  width 100%
  padding 2rem
  background $neBg
  margin-top 2rem
  animation: summary-enter .5s ease-out;
}

.content.is-group-summary {
  padding 1rem
}

.section {
  position: relative;
  padding 1.5rem

  &.has-border-bottom {
    border-bottom 1px solid #dddddd
    padding-bottom 2rem
    margin-bottom 1rem
  }

  .before-title {
    position relative
    font-size 14px
    line-height 1
  }

  .title {
    font-size 36px
    position relative
    margin-bottom 1.5rem
    user-select none
    font-weight bold
  }

  .title.is-small {
    font-size 24px
  }

  .section-index {
    user-select none
    position absolute
    left 8px
    top -35px
    font-size 100px
    color white
    font-weight bold
    z-index: 0;
    opacity .5
    pointer-events none
    white-space nowrap
  }
}

.card.is-title {
  background $link
  color white
  padding 1rem
  font-size 1.25rem
}
</style>
